import React from "react";

function CarIcon(props: any) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.75 8.25L4.875 4.875H13.125L14.25 8.25M13.125 12C12.8266 12 12.5405 11.8815 12.3295 11.6705C12.1185 11.4595 12 11.1734 12 10.875C12 10.5766 12.1185 10.2905 12.3295 10.0795C12.5405 9.86853 12.8266 9.75 13.125 9.75C13.4234 9.75 13.7095 9.86853 13.9205 10.0795C14.1315 10.2905 14.25 10.5766 14.25 10.875C14.25 11.1734 14.1315 11.4595 13.9205 11.6705C13.7095 11.8815 13.4234 12 13.125 12ZM4.875 12C4.57663 12 4.29048 11.8815 4.0795 11.6705C3.86853 11.4595 3.75 11.1734 3.75 10.875C3.75 10.5766 3.86853 10.2905 4.0795 10.0795C4.29048 9.86853 4.57663 9.75 4.875 9.75C5.17337 9.75 5.45952 9.86853 5.6705 10.0795C5.88147 10.2905 6 10.5766 6 10.875C6 11.1734 5.88147 11.4595 5.6705 11.6705C5.45952 11.8815 5.17337 12 4.875 12ZM14.19 4.5C14.04 4.065 13.62 3.75 13.125 3.75H4.875C4.38 3.75 3.96 4.065 3.81 4.5L2.25 9V15C2.25 15.1989 2.32902 15.3897 2.46967 15.5303C2.61032 15.671 2.80109 15.75 3 15.75H3.75C3.94891 15.75 4.13968 15.671 4.28033 15.5303C4.42098 15.3897 4.5 15.1989 4.5 15V14.25H13.5V15C13.5 15.1989 13.579 15.3897 13.7197 15.5303C13.8603 15.671 14.0511 15.75 14.25 15.75H15C15.1989 15.75 15.3897 15.671 15.5303 15.5303C15.671 15.3897 15.75 15.1989 15.75 15V9L14.19 4.5Z"
        fill="#91A4B7"
      />
    </svg>
  );
}

export default CarIcon;
